import { UseQueryOptions } from '@tanstack/react-query';
import { CuredApiPaths } from 'models/enums';
import useQuery from 'hooks/useQuery';

const useContactSubStatus = (reactQueryOptions?: UseQueryOptions<any, Error>) => {
    const path = CuredApiPaths.REPORT_CONTACTS_SUBSCRIPTION_STATUS;

    return useQuery('contacts-subscription-status', path, reactQueryOptions);
};

export default useContactSubStatus;
